import { Component } from '@angular/core';
import { saveAs } from 'file-saver/FileSaver';
import { ExcelReportService } from '../../_services/excel-report/excel-report.service';
import { FlowsheetService } from '../../_services/flowsheet.service';
import { CoreService } from '../../_services/core.service';

@Component({
  selector: 'sob-excel-report',
  templateUrl: './excel-report.component.html',
  styleUrls: ['./excel-report.component.css'],
})
export class ExcelReportComponent {
  filename: string;

  constructor(
    private xlsxSrv: ExcelReportService,
    private flowsheetService: FlowsheetService,
    private coreService: CoreService
  ) {}

  private downloadExcelReport(filename): void {
    if (this.currentCase.getActiveFlowsheet().isSubflowsheet()) {
      this.flowsheetService.exitToMainFlowsheet();
    }

    const excelFile = this.xlsxSrv.generateExcelReport();
    saveAs(new Blob([excelFile], { type: 'application/octet-stream' }), `${filename}.xlsx`);
  }

  generateExcel() {
    this.filename = this.filename.replace(/\s/g, '');

    if (this.filename.length > 0) {
      this.downloadExcelReport(this.filename);
      $('#excelReportModal').modal('hide');
      this.filename = '';
    }
  }

  get currentCase() {
    return this.coreService.currentCase;
  }
}
